import { Route, RouteObject } from 'react-router-dom';
import { ixIntegrationRoutes } from './integration/routes';

export interface ixRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: ixRoute[];
}

export const ixRoutes: ixRoute[] = [
  ...ixIntegrationRoutes
]